import React from 'react'
import { FormBlock } from '../components'
import { useState } from 'react'
import { useEffect } from 'react';
import services from '../../ioc/services';
import ModalContainer from './ModalContainer';

function FormsContainer() {

    const [forms, setForms] = useState([]);

    const [deleting, setDeleting] = useState(false);

    const [deleteForm, setDeleteForm] = useState(null);

    useEffect(() => {

        services.api.form.getForms()
            .then(res => {
                setForms(res)
            })
            .catch(err => {
                services.alert.toast.error(err)
            })

    }, [])

    const displayDeleteDialog = (form) => {
        
        setDeleteForm(form);
        setDeleting(true);
    }

    const handleDeleteForm = () => {
        
        services.api.form.deleteForm(deleteForm.id)
        .then(res => {
            services.alert.toast.success("Form deleted successfully");
            window.location.reload();
        })
        .catch(err=> services.alert.toast.error(err))

    }



    return (

        <>
            <div>
                <div className="grid gap-4 grid-cols-1 md:grid-cols-2 lg:grid-cols-4">
                    {forms.map(form => <FormBlock key={form.title} formItem={form} deleteAction={displayDeleteDialog} />)}
                </div>
            </div>

            {deleting && <ModalContainer
                title="Delete Form"
                isOpen={deleting}
                setIsOpen={setDeleting}
                contentStyle={
                    {
                        maxWidth: '500px',
                        maxHeight: '300px',
                        margin: 'auto',
                    }
                }
            >
                <div>
                    <p className=' text-center'>Are you sure you want to delete  {deleteForm.title}?</p>

                    <div className=' grid justify-around grid-cols-2 gap-8 items-center mt-12'>
                        <button
                            onClick={handleDeleteForm}
                            className='bg-red-400 text-white text-sm rounded-lg py-2 px-6'>Yes</button>
                        <button
                            onClick={() => setDeleting(false)}
                            className='bg-slate-500 text-white text-sm rounded-lg py-2 px-6'>No</button>
                    </div>
                </div>

            </ModalContainer>}
        </>


    )
}

export default FormsContainer